'use client';

var __jsx = React.createElement;
import React from 'react';
import FooterLangButton from '../lang-button';
import FooterCurrencyButton from '../currency-button';
import { useCustomer } from '@lib/context/shared/customer-context';
import LanguageCurrencyConfigModal from '@modules/layout/components/shared/lang-currency-config-modal';
import useCssModules from '@lib/hooks/use-css-modules';
const FooterConfigButtons = () => {
  var _cssModules$footers$f;
  const [configModalIsOpen, setConfigModalIsOpen] = React.useState(false);
  const {
    customerIsLogged
  } = useCustomer();
  const {
    cssModules
  } = useCssModules();
  const {
    configButtonsContainerClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerDefault) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx(React.Fragment, null, __jsx("div", {
    className: configButtonsContainerClassNames,
    onClick: () => setConfigModalIsOpen(true)
  }, __jsx(FooterLangButton, null), customerIsLogged ? __jsx(React.Fragment, null, __jsx(FooterCurrencyButton, null)) : null), __jsx(LanguageCurrencyConfigModal, {
    isOpen: configModalIsOpen,
    setIsOpen: setConfigModalIsOpen
  }));
};
export default FooterConfigButtons;